/* ELEMENT FOR MEN — HALLOWEEN 2026 LAYER (behaviour)
   Reads window.efmHW (printed by snippets/efm-halloween.liquid). Does nothing outside
   the date window, so it switches itself off after the end date even if left in the theme.
   Every piece is aria-hidden decoration; nothing here touches cart, price or checkout. */
(function () {
  'use strict';

  var cfg = window.efmHW || {};
  var root = document.documentElement;
  var now = Date.now();

  if (!cfg.end || now > cfg.end || (cfg.start && now < cfg.start)) {
    root.classList.remove('efm-hw', 'efm-hw--boo');
    var stale = document.querySelectorAll('[data-efm-hw]');
    for (var s = 0; s < stale.length; s++) stale[s].parentNode && stale[s].parentNode.removeChild(stale[s]);
    return;
  }

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg';

  function once(key) {
    try {
      if (sessionStorage.getItem(key)) return false;
      sessionStorage.setItem(key, '1');
      return true;
    } catch (e) {
      return true;
    }
  }

  function svgFromString(markup) {
    var wrap = document.createElement('span');
    wrap.innerHTML = markup;
    return wrap.firstChild;
  }

  var SPIDER =
    '<svg xmlns="' + NS + '" viewBox="0 0 32 32" aria-hidden="true" focusable="false">' +
    '<g stroke="#1C2A4B" stroke-width="1.4" fill="none" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M13 15 7 9 4 11M13 17 6 15 3 18M13 19 6 21 4 25M14 21 9 26 8 30"/>' +
    '<path d="M19 15 25 9 28 11M19 17 26 15 29 18M19 19 26 21 28 25M18 21 23 26 24 30"/>' +
    '</g>' +
    '<ellipse cx="16" cy="19" rx="4.2" ry="5" fill="#1C2A4B"/>' +
    '<circle cx="16" cy="12.6" r="2.8" fill="#1C2A4B"/>' +
    '<circle cx="15" cy="12.2" r=".6" fill="#F7F4EE"/><circle cx="17" cy="12.2" r=".6" fill="#F7F4EE"/>' +
    '</svg>';

  var WEB =
    '<svg xmlns="' + NS + '" viewBox="0 0 120 120" aria-hidden="true" focusable="false">' +
    '<path fill="none" stroke="currentColor" stroke-width=".9" stroke-linecap="round" d="M0 0L120 0M0 0L115.9 31.1M0 0L103.9 60M0 0L84.9 84.9M0 0L60 103.9M0 0L31.1 115.9M0 0L0 120' +
    'M22 0Q18.6 2.4 21.3 5.7Q17.3 7.2 19.1 11Q14.9 11.4 15.6 15.6Q11.4 14.9 11 19.1Q7.2 17.3 5.7 21.3Q2.4 18.6 0 22' +
    'M44 0Q37.2 4.9 42.5 11.4Q34.7 14.4 38.1 22Q29.8 22.8 31.1 31.1Q22.8 29.8 22 38.1Q14.4 34.7 11.4 42.5Q4.9 37.2 0 44' +
    'M68 0Q57.5 7.6 65.7 17.6Q53.6 22.2 58.9 34Q46 35.3 48.1 48.1Q35.3 46 34 58.9Q22.2 53.6 17.6 65.7Q7.6 57.5 0 68' +
    'M94 0Q79.5 10.5 90.8 24.3Q74 30.7 81.4 47Q63.6 48.8 66.5 66.5Q48.8 63.6 47 81.4Q30.7 74 24.3 90.8Q10.5 79.5 0 94' +
    'M118 0Q99.8 13.1 114 30.5Q93 38.5 102.2 59Q79.8 61.2 83.4 83.4Q61.2 79.8 59 102.2Q38.5 93 30.5 114Q13.1 99.8 0 118"/>' +
    '</svg>';

  /* 1. Ghosts on the buy buttons: CSS does the peek, JS adds the click "boo" */
  if (cfg.boo) {
    root.classList.add('efm-hw--boo');
    var BOO_SEL = 'buy-buttons button[type="submit"], .product-card__quick-add-button, .efm-sh__add, .efm-btn--solid, #cart-drawer button[name="checkout"], .efm-hw-cta';
    document.addEventListener('click', function (event) {
      if (reduceMotion || !event.target.closest) return;
      var btn = event.target.closest(BOO_SEL);
      if (!btn) return;
      btn.classList.remove('efm-hw-boo-go');
      void btn.offsetWidth;
      btn.classList.add('efm-hw-boo-go');
      setTimeout(function () { btn.classList.remove('efm-hw-boo-go'); }, 950);
    }, true);
  }

  function heroSection() {
    return document.querySelector('[id$="__image_with_text_overlay_AcHecU"]') ||
      document.querySelector('#main .shopify-section--image-with-text-overlay');
  }

  /* 2. Cobweb in the top corner of the homepage hero and the Start Here hero (.efm-hero is the live page) */
  if (cfg.web) {
    var hero = heroSection();
    if (hero) {
      if (getComputedStyle(hero).position === 'static') hero.style.position = 'relative';
      var web = document.createElement('div');
      web.className = 'efm-hw-web efm-hw-web--mobile-right';
      web.setAttribute('aria-hidden', 'true');
      web.setAttribute('data-efm-hw', '');
      web.appendChild(svgFromString(WEB));
      hero.appendChild(web);
    }
    var sh = document.querySelector('.efm-sh__hero, .efm-hero');
    if (sh) {
      var shSection = sh.closest('.efm-sh, .shopify-section') || sh;
      if (getComputedStyle(shSection).position === 'static') shSection.style.position = 'relative';
      var web2 = document.createElement('div');
      web2.className = 'efm-hw-web efm-hw-web--navy efm-hw-web--right';
      web2.setAttribute('aria-hidden', 'true');
      web2.setAttribute('data-efm-hw', '');
      web2.appendChild(svgFromString(WEB));
      shSection.appendChild(web2);
    }
  }

  /* 3. Fly-by ghost across the homepage hero, once per session */
  if (cfg.fly && !reduceMotion) {
    var flyHero = heroSection();
    if (flyHero && once('efm-hw-fly')) {
      setTimeout(function () {
        if (getComputedStyle(flyHero).position === 'static') flyHero.style.position = 'relative';
        flyHero.style.overflow = 'hidden';
        var fly = document.createElement('div');
        fly.className = 'efm-hw-fly';
        fly.setAttribute('aria-hidden', 'true');
        fly.setAttribute('data-efm-hw', '');
        var g = document.createElement('div');
        g.className = 'efm-hw-fly__ghost';
        fly.appendChild(g);
        flyHero.appendChild(fly);
        fly.addEventListener('animationend', function (e) {
          if (e.target === fly) fly.parentNode && fly.parentNode.removeChild(fly);
        });
      }, 2200);
    }
  }

  /* 4. The spider: drops from under the header once per session, climbs back on scroll or tap */
  if (cfg.spider && !reduceMotion && once('efm-hw-spider')) {
    setTimeout(function () {
      var header = document.querySelector('.shopify-section--header') || document.querySelector('header');
      var top = header ? Math.max(0, header.getBoundingClientRect().bottom) : 0;
      var spider = document.createElement('div');
      spider.className = 'efm-hw-spider';
      spider.setAttribute('aria-hidden', 'true');
      spider.setAttribute('data-efm-hw', '');
      spider.style.top = top + 'px';
      spider.style.setProperty('--efm-hw-drop', (window.innerWidth < 700 ? 64 : 104) + 'px');
      var thread = document.createElement('span');
      thread.className = 'efm-hw-spider__thread';
      var body = document.createElement('span');
      body.className = 'efm-hw-spider__body';
      body.appendChild(svgFromString(SPIDER));
      spider.appendChild(thread);
      spider.appendChild(body);
      document.body.appendChild(spider);

      var gone = false;
      function climb() {
        if (gone) return;
        gone = true;
        spider.classList.add('is-up');
        window.removeEventListener('scroll', onScroll);
        setTimeout(function () { spider.parentNode && spider.parentNode.removeChild(spider); }, 900);
      }
      function onScroll() { if (window.scrollY > 160) climb(); }

      requestAnimationFrame(function () {
        requestAnimationFrame(function () { spider.classList.add('is-down'); });
      });
      body.addEventListener('click', climb);
      window.addEventListener('scroll', onScroll, { passive: true });
      setTimeout(climb, 14000);
    }, 1400);
  }

  /* 5. Tap-to-copy on the code chips (Start Here band, cart drawer) */
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-efm-hw-copy]');
    if (!chip) return;
    event.preventDefault();
    var code = chip.getAttribute('data-efm-hw-copy');
    var label = chip.textContent;
    function done() {
      chip.classList.add('is-copied');
      chip.textContent = 'Copied';
      setTimeout(function () { chip.textContent = label; chip.classList.remove('is-copied'); }, 1600);
    }
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done, function () {});
      }
    } catch (e) {}
  });
})();